<app-navbar></app-navbar>
<div class="container-lg">
    <div class="my-container">
        <div class="row text-center">
            <div class="col-md-4">
                <div class="btn-group">
                    <div class="btn btn-primary" mwlCalendarPreviousView [view]="view" [(viewDate)]="viewDate"
                        (viewDateChange)="closeOpenMonthViewDay()">
                        Anterior
                    </div>
                    <div class="btn btn-outline-secondary" mwlCalendarToday [(viewDate)]="viewDate">
                        Hoy
                    </div>
                    <div class="btn btn-primary" mwlCalendarNextView [view]="view" [(viewDate)]="viewDate"
                        (viewDateChange)="closeOpenMonthViewDay()">
                        Siguiente
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <h3>{{ viewDate | calendarDate:(view + 'ViewTitle'):'Es' | uppercase  }}</h3>
            </div>
            <div class="col-md-4">
                <div class="btn-group">
                    <div class="btn btn-primary" (click)="setView(CalendarView.Month)"
                        [class.active]="view === CalendarView.Month">
                        Mes
                    </div>
                    <div class="btn btn-primary" (click)="setView(CalendarView.Week)"
                        [class.active]="view === CalendarView.Week">
                        Semana
                    </div>
                    <div class="btn btn-primary" (click)="setView(CalendarView.Day)"
                        [class.active]="view === CalendarView.Day">
                        Dia
                    </div>
                </div>
            </div>
        </div>
        <br />
        <div [ngSwitch]="view">
            <mwl-calendar-month-view *ngSwitchCase="CalendarView.Month" [viewDate]="viewDate" [events]="events"
                [activeDayIsOpen]="activeDayIsOpen" (dayClicked)="dayClicked($event.day)" [locale]="'Es'"
                (eventClicked)="handleEvent('Clicked', $event.event)" (eventTimesChanged)="eventTimesChanged($event)">
            </mwl-calendar-month-view>
            <mwl-calendar-week-view *ngSwitchCase="CalendarView.Week" [viewDate]="viewDate" [events]="events"
                (eventClicked)="handleEvent('Clicked', $event.event)" (eventTimesChanged)="eventTimesChanged($event)"
                [locale]="'Es'">
            </mwl-calendar-week-view>
            <mwl-calendar-day-view *ngSwitchCase="CalendarView.Day" [viewDate]="viewDate" [events]="events"
                (eventClicked)="handleEvent('Clicked', $event.event)" (eventTimesChanged)="eventTimesChanged($event)"
                [locale]="'Es'">
            </mwl-calendar-day-view>
        </div>

        <!-- Everything you see below is just for the demo, you don't need to include it in your app -->

        <br /><br /><br />

        <h3>
            Eventos
            <button class="btn btn-primary float-right" data-toggle="modal" data-target="#add-diary">
                Agregar evento
            </button>
            <div class="clearfix"></div>
        </h3>

        <div class="table-responsive">
            <table class="table table-bordered">
                <caption>Tabla de Eventos</caption>
                <thead>
                    <tr>
                        <th scope="col">Tarea</th>
                        <th scope="col">Descripcion</th>
                        <th scope="col">Empieza</th>
                        <th scope="col">Termina</th>
                        <th scope="col">Remover</th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let event of diaryEvents">
                        <td>
                            <input type="text" class="form-control" [(ngModel)]="event.title" />
                        </td>
                        <td>
                            <input type="text" class="form-control" [(ngModel)]="event.description" />
                        </td>
                        <td>
                            <input class="form-control" type="datetime-local" mwlFlatpickr [(ngModel)]="event.start"
                                [altInput]="true" [convertModelValue]="true" [enableTime]="true"
                                dateFormat="dd-mm-YYYYTH:i" altFormat="j-m-Y H:i" placeholder="Not set"
                                [locale]="Espanol" />
                        </td>
                        <td>
                            <input class="form-control" type="datetime-local" mwlFlatpickr [(ngModel)]="event.end"
                                [altInput]="true" [convertModelValue]="true" [enableTime]="true"
                                dateFormat="dd-mm-YYYYTH:i" altFormat="j-m-Y H:i" placeholder="Not set"
                                [locale]="Espanol" />
                        </td>
                        <td>
                            <button class="btn btn-danger" (click)="deleteEvent(event)">
                                Delete
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <ng-template #modalContent let-close="close">
            <div class="modal-header">
                <h5 class="modal-title">Event action occurred</h5>
                <button type="button" class="close" (click)="close()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div>
                    Action:
                    <pre>{{ modalData?.action }}</pre>
                </div>
                <div>
                    Event:
                    <pre>{{ modalData?.event.description }}</pre>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-outline-secondary" (click)="close()">
                    OK
                </button>
            </div>
        </ng-template>
    </div>
</div>

<!-- Add News ∆ Modal ∆ -->
<div class="modal fade" id="add-diary" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="add-news-title" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form #addNewsLogin="ngForm" (submit)="addDiary()">
                <div class="modal-header">
                    <h5 class="modal-title" id="add-agenda-title">Agregar Evento</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group pb-4">
                        <label for="title" class="group-title pb-1">Título</label>
                        <input type="text" class="form-control" id="title" name="title" #title="ngModel"
                            [(ngModel)]="agenda.title" required aria-required="true">
                    </div>

                    <div class="form-group pb-4">
                        <label for="add-introduction" class="group-title pb-1">Breve descripción</label>
                        <textarea type="introduction" class="form-control" id="add-introduction" #description="ngModel"
                            [(ngModel)]="agenda.description" name="introduction" required aria-required="true" rows="3">
                        </textarea>
                    </div>
                    <div class="form-group pb-4">
                        <label for="start" class="group-title pb-1">Inicio del evento</label>
                        <input class="form-control" type="dateFtime-local" mwlFlatpickr [altInput]="true"
                            [convertModelValue]="true" [enableTime]="true" dateFormat="dd-mm-YYYYTH:i" id="start"
                            altFormat="j-m-Y H:i" placeholder="Not set" [locale]="Espanol" name="start" #start="ngModel"
                            [(ngModel)]="agenda.start" />
                    </div>
                    <div class="form-group pb-4">
                        <label for="role" class="form-label">Evento</label>
                        <select type="text" id="color" name="color" [(ngModel)]="agenda.color" class="form-control"
                            placeholder="color">
                            <option *ngFor="let color of colorslbl; let i = index" [ngValue]="colors[color.name]">
                                {{ color.type }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group pb-4">
                        <label for="text" class="group-title pb-1">Finalización del evento</label>
                        <input class="form-control" type="datetime-local" mwlFlatpickr [altInput]="true"
                            [convertModelValue]="true" [enableTime]="true" dateFormat="dd-mm-YYYYTH:i"
                            altFormat="j-m-Y H:i" placeholder="Not set" [locale]="Espanol" name="end" #end="ngModel"
                            [(ngModel)]="agenda.end" />

                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                    <button type="button" class="btn btn-primary" type="submit">Agregar Evento</button>
                </div>
            </form>
        </div>
    </div>
</div>